// extracted by mini-css-extract-plugin
module.exports = {"d4w3sxd":"d4w3sxd"};